import { z } from "zod";

export const partnerApplySchema = z.literal("");
export type PartnerApplyType = z.infer<typeof partnerApplySchema>;
